import React, { useState, useEffect } from 'react';

const LoadingPanel: React.FC = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 20);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-panel-overlay">
      <div className="loading-panel-container">
        <div className="loading-progress-bar-container">
          <div 
            className="loading-progress-bar"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="loading-text-container">
          <span className="loading-text">Loading:</span>
          <span className="loading-percentage">{progress}%</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingPanel;
